import React from 'react';
import './PrintableForm.css';

const MedicalAuthorization: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form-container">
      <div className="no-print actions-bar">
        <button onClick={() => window.history.back()} className="back-btn">← Back to Forms</button>
        <button onClick={handlePrint} className="print-btn">🖨️ Print / Save as PDF</button>
      </div>

      <div className="printable-form">
        <div className="form-header">
          <h1>The Pet Nanny of Weston</h1>
          <p className="tagline">Licensed • Bonded • Insured</p>
          <p className="contact">thepetnannyofweston@gmail.com</p>
        </div>

        <h2 className="form-title">Emergency Medical Authorization Form</h2>

        <div className="form-section">
          <h3>Pet Owner Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Full Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Primary Phone:</label>
              <input type="tel" />
            </div>
            <div className="form-field half-width">
              <label>Secondary Phone:</label>
              <input type="tel" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Email Address:</label>
              <input type="email" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Pet Information</h3>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Pet's Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Species & Breed:</label>
              <input type="text" placeholder="e.g., Dog - Golden Retriever" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field third-width">
              <label>Age:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Weight:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Color/Markings:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Primary Veterinarian</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Veterinary Clinic Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Veterinarian's Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Address:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Alternative Veterinarian (if primary is unavailable)</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Veterinary Clinic Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
            <div className="form-field half-width">
              <label>Address:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Medical History</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Known Medical Conditions:</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Current Medications:</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Known Allergies (medications, foods, environmental):</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Emergency Care Authorization</h3>
          <p className="section-note" style={{marginBottom: '1rem'}}>
            <strong>Please read carefully and initial each statement:</strong>
          </p>
          
          <div className="form-row">
            <div className="form-field full-width">
              <div style={{border: '2px solid #2c5530', padding: '1rem', borderRadius: '8px', marginBottom: '1rem'}}>
                <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1rem'}}>
                  <input type="text" style={{width: '60px', textAlign: 'center'}} placeholder="Initial" />
                  <p style={{margin: 0, flex: 1}}>
                    I hereby authorize <strong>The Pet Nanny of Weston</strong> and its designated representatives to seek 
                    emergency veterinary medical treatment for the above-named pet if, in their judgment, such treatment is necessary.
                  </p>
                </div>
                
                <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '1rem'}}>
                  <input type="text" style={{width: '60px', textAlign: 'center'}} placeholder="Initial" />
                  <p style={{margin: 0, flex: 1}}>
                    I understand that every attempt will be made to contact me before any treatment is administered. However, 
                    if I cannot be reached, I authorize The Pet Nanny of Weston to approve emergency treatment on my behalf.
                  </p>
                </div>
                
                <div style={{display: 'flex', alignItems: 'flex-start', gap: '1rem'}}>
                  <input type="text" style={{width: '60px', textAlign: 'center'}} placeholder="Initial" />
                  <p style={{margin: 0, flex: 1}}>
                    I understand and agree that I am financially responsible for all veterinary expenses incurred for emergency 
                    care of my pet, including but not limited to examination fees, diagnostic tests, medications, surgical procedures, 
                    hospitalization, and follow-up care.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Maximum Emergency Spending Authorization</h3>
          <p className="section-note">
            Please indicate the maximum amount you authorize to be spent on emergency veterinary care without 
            prior contact. If you cannot be reached and costs exceed this amount, The Pet Nanny of Weston will 
            make decisions in the best interest of your pet.
          </p>
          <div className="form-row">
            <div className="form-field full-width">
              <div style={{display: 'flex', flexWrap: 'wrap', gap: '1rem', marginTop: '0.5rem'}}>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> $500
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> $1,000
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> $2,000
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> $5,000
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Unlimited
                </label>
                <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                    <input type="checkbox" /> Other: $
                  </label>
                  <input type="text" style={{width: '100px'}} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Payment Information</h3>
          <p className="section-note">
            Please note: Payment for emergency veterinary services may be required at the time of service. 
            You may be contacted to provide payment information directly to the veterinary clinic.
          </p>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Preferred Payment Method:</label>
              <div style={{display: 'flex', gap: '1rem', marginTop: '0.25rem', flexWrap: 'wrap'}}>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Credit Card on File
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Pet Insurance
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Other
                </label>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Pet Insurance Provider & Policy Number (if applicable):</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Signatures</h3>
          <p className="section-note">
            By signing below, I certify that I have read, understand, and agree to all terms stated in this 
            emergency medical authorization form. This authorization remains in effect for all services provided 
            by The Pet Nanny of Weston until revoked in writing.
          </p>
          
          <div className="subsection">
            <h4>Pet Owner</h4>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Printed Name:</label>
                <input type="text" />
              </div>
              <div className="form-field half-width">
                <label>Date:</label>
                <input type="date" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field full-width">
                <label>Signature:</label>
                <div className="signature-line"></div>
              </div>
            </div>
          </div>

          <div className="subsection">
            <h4>Emergency Contact / Secondary Authorization (Optional)</h4>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Printed Name:</label>
                <input type="text" />
              </div>
              <div className="form-field half-width">
                <label>Relationship:</label>
                <input type="text" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field half-width">
                <label>Phone Number:</label>
                <input type="tel" />
              </div>
              <div className="form-field half-width">
                <label>Date:</label>
                <input type="date" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-field full-width">
                <label>Signature:</label>
                <div className="signature-line"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-footer">
          <p>Page 1 of 1</p>
          <p>The Pet Nanny of Weston • thepetnannyofweston@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default MedicalAuthorization;
